import { ReactNode } from 'react';
import VoyagersClubJoinMscVoyagerClubLayout from './VoyagersClubJoinMscVoyagerClubLayout';
import { VoyagersClubJoinMscVoyagerClubProps } from '@msc-b2c/interfaces/types';

export function VoyagersClubJoinMscVoyagerClubWrapper(
  props: Readonly<VoyagersClubJoinMscVoyagerClubProps>
): ReactNode {
  return <VoyagersClubJoinMscVoyagerClubLayout {...props} />;
}

export default VoyagersClubJoinMscVoyagerClubWrapper;

VoyagersClubJoinMscVoyagerClubWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/voyagersclubjoinmscvoyagerclub';
